import { useEffect, useState } from "react";
import { modalStore } from "components/Common/Alert/AlertManager";

export const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOffline = () => {
      setIsOnline(false);
      modalStore.register({
        id: "network-error-modal",
        title: "네트워크 연결 오류",
        content: "인터넷 연결이 끊어졌습니다. 연결 상태를 확인해 주세요.",
      });
    };

    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return isOnline;
};
